export default "__VITE_ASSET__DMVsX8Cy__"